import { License } from '@app/modules/license/license.types';

/**
 * The single device uuid a license's transcripts arrive on over WebSocket.
 *
 * Multi-kit microphonekit licenses carry their device id in `uuids[]` with the
 * scalar `uuid` unset; all mics report on this one channel and `micId`
 * discriminates them (the same shape the single Firestore collection had).
 * Prefers the scalar `uuid`, falling back to `uuids[0]` — the convention the
 * guest flow already uses.
 */
export function licenseDeviceUuid(license: License): string | undefined {
  return license.uuid ?? license.uuids?.[0];
}
